import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormControl } from '@angular/forms';
import { ValidationTypes } from './validator-const.model';
import { BaseValidator } from './base.directive';
import { Moment } from 'moment';

@Directive({
    selector: `[cpqDate]`,
    providers: [{ provide: NG_VALIDATORS, useExisting: DateDirective, multi: true }],
    standalone: false
})
export class DateDirective extends BaseValidator implements Validator {
    constructor() {
        super();
    }

    validate(c: FormControl<Moment>): ValidationErrors {
        let isValid = true;
        if (c) {
            if (c.value === undefined) {
                return null;
            }
            isValid = c.value === null || c.value.isValid();
        }
        return isValid ? null : this.createMessage(ValidationTypes.cpqDate, 'Date is not valid');
    }
}
